/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

/**
 * Root Imports
*/

import { CssClassName } from '~/util/Css';

/**
 * Local Imports
*/

import { ValuedField } from './ValuedField';

/**
 * Locals
*/

function HtmlLabel(props) {
  return (
    <label className={ CssClass.Label }>
      { props.children }
    </label>
  );
}

function ComponentLabel(props) {
  return props.component;
}

/**
 * Exports
*/

/**
 * 
 */
export function LabeledField({ labelPosition, labelType, ...props }) {
  /** Renderers **/

  /**
   * 
   */
  const renderLabel = () => {
    if (typeof props.label === 'string') {
      return (
        <HtmlLabel>
          { 
            labelPosition !== 'before' ? null
              : props.label
          }
          {
            labelType === 'contain'
              ? props.children : null
          }
          { 
            labelPosition !== 'after' ? null
              : props.label
          }
        </HtmlLabel>
      );
    } else {
      return (
        <ComponentLabel component={ props.label }>
          {
            labelType === 'contain'
              ? props.children : null
          }
        </ComponentLabel>
      );
    }
  };

  /**
   * 
   */
  const renderBeforeLabel = () => {
    return (
      <Fragment>
        {
          props.label && renderLabel()
        }
        {
          !props.label || labelType === 'outside'
            ? props.children : null
        }
      </Fragment>
    );
  };

  /**
   * 
   */
  const renderAfterLabel = () => {
    return (
      <Fragment>
        {
          !props.label || labelType === 'outside'
            ? props.children : null
        }
        {
          props.label && renderLabel()
        }
      </Fragment>
    );
  };
  
  /** Factories **/

  /**
   * 
   */
  const ContainerFactory = ({ children }) => {
    const config = {
      className: CssClassName(props.containerClassName),
      children: children
    };

    return React.cloneElement(props.container, config);
  };
  
  /** Output **/

  return (
    <ValuedField { ...props }>
    {
      labelPosition === 'before'
        ? renderBeforeLabel()
      : labelPosition === 'after'
        ? renderAfterLabel()
      : null
    }
    </ValuedField>
  );
}

LabeledField.propTypes = {
  container: PropTypes.oneOfType([ PropTypes.node, PropTypes.func ]),
  containerClassName: PropTypes.oneOfType([ PropTypes.node, PropTypes.func ]),
  name: PropTypes.string.isRequired,
  className: PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
  label: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  labelType: PropTypes.oneOf([ 'outside', 'contain' ]),
  labelPosition: PropTypes.oneOf([ 'before', 'after' ]),
  hasError: PropTypes.bool
};

LabeledField.defaultProps = {
  container: <div/>,
  labelType: 'outside',
  labelPosition: 'before'
};